import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import LoadingEffect from "../../components/LoadingEffect";
import { apiCupSales } from "../../services/data";
import { Button } from "../../styles-components/Buttons";
import { Container } from "../../styles-components/Container";
import {
  Form,
  FormHeader,
  Label,
  Row,
} from "../../styles-components/FormItens";
import UseRedirectView from "../../utils/UseRedirectView";

const FormCupSales = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [places, setPlaces] = useState([]);
  const [cups, setCups] = useState([]);
  const { register, handleSubmit, setValue, watch } = useForm();

  async function fetchDatas() {
    await apiCupSales.index().then((response) => {
      setCups(response.data.data.produto);
      setPlaces(response.data.data.places);
      setIsLoading(false);
    });
  }

  useEffect(() => {
    fetchDatas();
  }, []);

  const onSubmit = async (data) => {
    try {
      var testNotNull = false;
      cups.map((item) => {
        if (data[`cup_${item.id}`]) {
          testNotNull = true;
        }
      });
      if (testNotNull) {
        var id = null;
        await apiCupSales.store(data).then((response) => {
          id = response.data.data.id;
        });
        UseRedirectView.to(`venda/copos/cadastrado/${id}`);
      } else {
        toast.error("Pelo menos um dos campos precisa ser preenchido!");
      }
    } catch (e) {
      toast.error("Algo deu errado na inserção!");
    }
  };

  return (
    <>
      {isLoading ? (
        <LoadingEffect />
      ) : (
        <>
          <Container>
            <FormHeader>
              <h1>Informar venda</h1>
              <Button
                color="--white"
                backgroundColor="--orange"
                onClick={() => UseRedirectView.to("venda/copos")}
              >
                Voltar
              </Button>
            </FormHeader>
            <Form onSubmit={handleSubmit(onSubmit)}>
              <label>
                <b>LOCAL:</b>
              </label>
              <select
                style={{ width: "100%" }}
                {...register("place", {
                  required: { value: true, message: "informe uma local!" },
                })}
              >
                <option></option>
                {places.map((place) => (
                  <option key={place.id}>{place.description}</option>
                ))}
              </select>
              <Label style={{ marginTop: "10px" }}>Data:</Label>
              <input
                {...register("date", { required: true })}
                type="date"
                required
              />
              {cups.map((item) => (
                <div key={item.id} style={{ marginTop: "10px" }}>
                  <Label>{item.nome} (cento):</Label>
                  <input
                    {...register(`cup_${item.id}`)}
                    type="number"
                    style={{ width: "100%" }}
                  />
                </div>
              ))}
              <Button
                color="--white"
                backgroundColor="--orange"
                align="flex-end"
              >
                Criar
              </Button>
            </Form>
          </Container>
        </>
      )}
    </>
  );
};

export default FormCupSales;
